import { render } from "./FeedmillForm.vue?vue&type=template&id=f4390fa4"
import script from "./FeedmillForm.vue?vue&type=script&lang=js"
export * from "./FeedmillForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__